import { useState } from 'react'
import { useTranslation } from 'react-i18next'
import { Navigate, useLoaderData, useNavigate } from 'react-router-dom'
import Button from '../../components/Button'
import Heading from '../../components/Heading'
import PageLayout from '../../components/PageLayout'
import PasswordInput from '../../components/PasswordInput'
import { setPasswordInSessionStorage } from '../../helpers/sessionStorage'
import { validatePassword } from '../../helpers/validations'
import { IsUserSignedInLoaderData } from '../../loaders/isUserSignedInLoader'

export default function PasswordPage() {
  const [password, setPassword] = useState('')
  const [passwordValid, setPasswordValid] = useState(true)

  const { isUserSignedIn } = useLoaderData() as IsUserSignedInLoaderData
  const navigate = useNavigate()
  const { t } = useTranslation()

  if (isUserSignedIn) {
    return <Navigate to="/sign-up/preparing" />
  }

  const isPasswordValid = validatePassword(password)

  const handleSubmit = (event: React.FormEvent<HTMLFormElement>) => {
    event.preventDefault()

    if (isPasswordValid) {
      setPasswordInSessionStorage(password)
      navigate('/sign-up/email')
    } else {
      setPasswordValid(false)
    }
  }

  return (
    <PageLayout>
      <div className="shrink-0">
        <Heading
          subtitle={t('pages.signUp.password.subheading')}
          title={t('pages.signUp.password.heading')}
        />
      </div>

      <div className="flex grow flex-col justify-between space-y-7">
        <div className="flex grow flex-col items-center justify-center space-y-7">
          <div className="w-full max-w-[338px] space-y-7">
            <form className="space-y-3" onSubmit={handleSubmit}>
              <PasswordInput
                autoComplete="new-password"
                autoFocus
                bgColor={'#FFFFFF'}
                invalid={!passwordValid}
                name="password"
                onChange={(event) => setPassword(event.target.value)}
              />
              <p
                className={
                  passwordValid
                    ? 'text-sm text-[#a1a1a1]'
                    : 'text-custom-error text-sm'
                }
              >
                {t('pages.signUp.password.helperText')}
              </p>
              <Button
                dataTestId="button-continue-credentials"
                disabled={password.length < 1}
                title={t('shared.continue')}
                type="submit"
              />
            </form>
          </div>
        </div>
      </div>
    </PageLayout>
  )
}
